import styled from "styled-components";
import DownAngle from "../../../assets/img/icons/DownAngle.svg";
import CampaignkeywordAsider from "../../Campaigns/CampaignAssets/Components/CampaignkeywordAsider";
import TemplateAsider from "../../Campaigns/CampaignAssets/Components/AdhocTemplates/TemplateAsider";
import CampaignAsiderNew from "../../Campaigns/CampaignAssets/Components/CampaignAsider";
import ProfileAsider from "../../Campaigns/Audience/People/ProfileAsider";
import { ICampaignsName } from "modules/Campaigns/interfaces";
import { AssetType } from "modules/Campaigns/utils";
import classNames from "classnames";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { GILL_LOADING } from "constants/index";

type Props = {
  isToggle: boolean;
  ProfileSidebar?: boolean;
  campaignAsider?: boolean;
  showTemplateAsider: boolean;
  audienceAsider: boolean;
  adhocAsider: boolean;
  className?: string;
  fitContent?: boolean;
  topMargin?: string;
  rightMargin?: string;
  campaignName: string;
  selectedCampaign: number;
  campaignItems: ICampaignsName[];
  handleSelectedCampaign: any;
  onClickCreateCampaign: any;
  handleCancelCreateCampaign: any;
  setToggleCampaignSaveDisable: any;
  handleOnRemoveCampaignKeyword: any;
  toggleCampaignSaveDisable: any;
  setCampaignName: any;
  handleCreateNewCampaign: any;
  handleAddPeople: any;
  setCampaignKeywords: any;
  setShowTemplateAsider?: any;
  handleCancelTemplateAsider: any;
  campaignKeywords?: Array<string>;
  disableMaxHeight?: boolean;
  handleOnClickBrowsePeople?: any;
  onClickAudienceDone?: any;
  selectedContactIds?: number[];
  selectedListIds?: number[];
  hideRecommendedList?: boolean;
  isPersonAdded?: any;
  enableScrollForContacts?: boolean;
  subtractWidth?: string;
  setSelectedTemplateId: any;
  setSelectedTemplateName: any;
  selectedTemplateId: number;
  selectedTemplateName: string;
  setSelectedTemplateImage: any;
  handleAdhocNameInput?: any;
  setToggleDisabled?: any;
  assetType?: string;
};

const TemplateFloatingSidebar: React.FC<Props> = ({
  isToggle,
  children,
  className,
  showTemplateAsider,
  campaignAsider,
  audienceAsider,
  rightMargin,
  topMargin,
  fitContent,
  ProfileSidebar,
  handleOnClickBrowsePeople,
  handleCancelCreateCampaign,
  handleOnRemoveCampaignKeyword,
  setToggleCampaignSaveDisable,
  toggleCampaignSaveDisable,
  setCampaignName,
  setCampaignKeywords,
  handleCreateNewCampaign,
  campaignName,
  campaignKeywords,
  onClickAudienceDone,
  handleAddPeople,
  selectedContactIds,
  selectedListIds,
  hideRecommendedList,
  isPersonAdded,
  enableScrollForContacts,
  subtractWidth,
  disableMaxHeight,
  setSelectedTemplateId,
  selectedTemplateId,
  setSelectedTemplateName,
  setSelectedTemplateImage,
  handleAdhocNameInput,
  setToggleDisabled,
  assetType
}) => {
  const isAIEmail = assetType === AssetType.AI_EMAIL
  const isLoading = useSelector((state: RootState) => state.aiEmail.loading)

  return (
    <Wrapper
      rightMargin={rightMargin}
      topMargin={topMargin}
      fitContent={fitContent}
      className={`${isToggle ? "open" : ""} ${className === undefined ? "" : className}`}
    >
      {/* toggle open class to view right sidebar */}
      <div className={classNames("expandable", { aiEmailDrawer: isAIEmail })}>
        <div className="opener">
          {/* Making this component general by accepting children from props*/}
          {/* {ProfileSidebar && <ProfileAsider aToggle={campaignAsider} />} */}
        </div>
        <div className="right-sidebar">{children}</div>
        {campaignAsider && (
          <CampaignAsiderNew
            aToggle={campaignAsider}
            onCancel={handleCancelCreateCampaign}
            handleOnClickBrowsePeople={handleOnClickBrowsePeople}
            campaignKeywords={campaignKeywords}
            setCampaignKeywords={setCampaignKeywords}
            handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
            campaignName={campaignName}
            setCampaignName={setCampaignName}
            handleCreateNewCampaign={handleCreateNewCampaign}
            toggleCampaignSaveDisable={toggleCampaignSaveDisable}
            setToggleCampaignSaveDisable={setToggleCampaignSaveDisable}
            assetFlow={true}
          />
        )}
        {audienceAsider && (
          <CampaignkeywordAsider
            isToggle={audienceAsider}
            onClickAudienceDone={onClickAudienceDone}
            handleAddPeople={handleAddPeople}
            selectedContactIds={selectedContactIds}
            selectedListIds={selectedListIds}
            hideRecommendedList={hideRecommendedList}
            isPersonAdded={isPersonAdded}
            enableScrollForContacts={enableScrollForContacts}
            subtractWidth={subtractWidth}
            disableMaxHeight={disableMaxHeight}
          />
        )}
        {showTemplateAsider && (
          <TemplateAsider
            isToggle={showTemplateAsider}
            setSelectedTemplateId={setSelectedTemplateId}
            setSelectedTemplateName={setSelectedTemplateName}
            setSelectedTemplateImage={setSelectedTemplateImage}
            handleAdhocNameInput={handleAdhocNameInput}
            selectedTemplateId={selectedTemplateId}
            setToggleDisabled={setToggleDisabled}
          />
        )}
        {isAIEmail ?
          <LoadingModal
            visible={isLoading}
            centered
            width="530px"
            className="generating-email"
          >
            <img src={GILL_LOADING} alt="gill-data" className="gill-loading" />
            <h4 className="heading-loading-popup">Generating your emails...</h4>
            <p className="text-loading-popup">Please hold tight while I take a few minutes to generate
              your personality based emails.</p>
          </LoadingModal>

          : null}
      </div>
    </Wrapper>
  );
};

export default TemplateFloatingSidebar;

interface IWrapperProps {
  rightMargin?: string;
  topMargin?: string;
  fitContent?: boolean;
}


const LoadingModal = styled(Modal)`
  .ant-modal-content{
    border-radius: 18px;
    text-align: center;
   
    .ant-modal-footer, .ant-modal-close-x {
      display: none !important;
    }
    .ant-modal-body{
      padding: 50px 60px;

      .gill-loading {
       min-width: 186px;
       width: 186px;
       min-height: 186px;
      }

      h4.heading-loading-popup{
        font-family: 'Roboto slab';
        font-size: 32px;
        letter-spacing: -0.8;
        line-height: 1.469;
        color: #424B50;
        font-weight: 700;
        margin: 0 0 20px 0;
        margin-top: -20px;
        
      }
      .text-loading-popup{
        font-family: 'Roboto';
        font-size: 16px;
        line-height: 22px;
        font-weight:  400;
        letter-spacing: -0.56;
      }
    }
    .ant-modal-footer{
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    }
  }
`;

const Wrapper = styled("div") <IWrapperProps>`
  right: -3000px;
  position: fixed;
  min-width: 530px;
  top: 0;
  z-index: 15;
  transition: 0.5s;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    min-width: 410px;
  }
  &.audience-sidebar {
    width: calc(100vw - 515px);
    min-width: none !important;
    .right-sidebar {
      width: 100% !important;
      padding: 50px 40px 30px 40px !important;
    }
  }
  .aiEmailDrawer {
    .right-sidebar {
      padding: 20px 0px 0px 0px!important;
      .scroll-Wrapper-two {
       padding: 0px 20px !important;
       height: calc(100vh - 410px);
       overflow: scroll;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: calc(100vh - 385px);
        }
      }
    }
  }
  // &.new-asset-wrapper,
  &.detail-person-view {
    right: -1250px;
    min-width: 530px;

    .right-sidebar {
      width: 530px !important;
      max-height: 100vh;
      overflow: auto;
      scrollbar-width: thin;
      scrollbar-color: #001760 #efefef;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 410px !important;
      }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
  &.open {
    right: ${(props) => (props.rightMargin ? (props) => props.rightMargin : "0px")};
    top: ${(props) => (props.topMargin ? (props) => props.topMargin : "")};
    transition: 0.5s;
  }
  .expandable {
    display: flex;
    align-items: flex-start;
    height: 100vh;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 10%);
    border-left: 1px solid #cfcfcf;
    float: right;
    width: ${(props) => (props.fitContent ? "fit-content" : "100%")};
    .opener {
      display: flex;
    }
    .right-sidebar {
      width: ${(props) => (props.fitContent ? "fit-content" : "530px")};
      display: flex;
      flex-direction: column;
      height: 100vh;
      padding: 20px;
      padding-bottom: 0px;
      position: relative;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 410px;
      }
      /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25){
        width: 550px;
        padding: 20px 35px;
      } */
      .header-section {
        .first-row {
          display: flex;
          justify-content: flex-end;
        }
        .second-row {
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          h4 {
            color: #424b50;
            font-size: 46px;
            font-family: "Roboto Slab", serif;
            line-height: 0.98;
            margin-bottom: 0;
            font-weight: bold;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 36px;
            }
          }
          .scheduale-switch {
            span {
              font-family: "robotomedium", sans-serif;
            }
            span.active-text {
              font-family: "robotomedium", sans-serif;
              font-size: 16px;
              color: #717171;
              font-weight: 500;
            }
          }
        }
      }
      .curated-list {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow-y: auto;
        padding-left: 2px;
        padding-right: 2px;
        height: calc(100vh - 265px);
        font-family: "Roboto Slab", serif;
        scrollbar-color: #001760 transparent;
        scrollbar-width: none;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: calc(100vh - 210px);
        }
        &::-webkit-scrollbar {
          display: none;
        }
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        input {
          font-size: 16px !important;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 7px 18px;
          }
        }
        .input-with-upload {
          position: relative;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding-top: 4px !important;
          }
          .ant-upload-list {
            position: absolute;
            left: -5px;
            top: 11px;
            .anticon {
              float: left;
            }
            .ant-upload-list-item-card-actions {
              margin-top: 5px;
              .ant-upload-list-text-container {
                max-width: 410px;
              }
            }
          }
          div.ant-upload {
            position: absolute;
            right: 0;
            top: 35px;
            span.browse {
              border: 1.25px solid rgb(39, 206, 10);
              border-radius: 6px;
              font-size: 13px;
              color: rgb(39, 206, 10);
              font-weight: 700;
              font-family: "helveticaneuebold";
              padding: 6px 10px;
              letter-spacing: 0.5px;
            }
          }
        }
        .input-box {
          .ant-radio-group {
            margin-bottom: 16px;
            label {
              margin-right: 50px;
              .ant-radio-inner {
                border-color: #b0b0b0;
                &:after {
                  background-color: #b0b0b0;
                }
              }
            }
            span {
              color: #5e7079;
              font-size: 16px;
              font-weight: 500;
              font-family: "robotomedium";
            }
          }
          .same-email {
            color: #5e7079;
            font-size: 16px;
            font-weight: 500;
            font-family: "robotomedium";
            margin-top: 10px;
            cursor: pointer;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              line-height: 18px;
            }
          }
          .publish-label {
            color: #5e7079;
            font-size: 18px;
            font-family: "Roboto Slab", serif;
            padding-bottom: 10px;
            padding-top: 40px;
            font-weight: 600;
            line-height: 20px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding-top: 25px;
            }
          }
          .ant-select-selector {
            padding: 10px 15px;
            height: auto;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 7px 15px;
            }
            .ant-select-selection-item {
              color: #7e7e7e;
              font-size: 16px;
              font-weight: 600;
              font-family: "robotoregular";
            }
            &.error-select {
              border: 2px solid #ffa112 !important;
            }
          }
          .error-select .ant-select-selector {
            border: 1px solid #ffa112 !important;
            box-shadow: none !important;
          }
          .ant-select-arrow {
            .anticon {
              background: url(${DownAngle});
              background-repeat: no-repeat;
              background-position: center;
              svg {
                opacity: 0;
              }
            }
            &:before {
              margin-top: -4px;
              content: "" !important;
              border-left: 1px solid #dddddd;
              display: block;
              height: 22px;
              margin-right: 8px;
              margin-left: -12px;
            }
          }
        }
        .compliance-check {
          background: rgba(0, 23, 96, 0.1);
          border: 1px solid rgba(0, 23, 96, 0.23);
          border-radius: 13px;
          padding: 20px 24px;
          margin-bottom: 10px;
          label {
            color: rgb(94, 112, 121);
            font-family: "robotoregular";
            font-size: 20px;
            font-weight: 600;
            cursor: pointer;
            span {
              background-color: rgb(255, 255, 255);
            }
          }
          p {
            color: rgb(94, 112, 121);
            text-align: left;
            font-size: 16px;
            font-family: "robotoregular";
            clear: both;
            letter-spacing: -0.444444px;
            margin-bottom: 0;
          }
        }
      }
      .bottom-floating-action {
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        justify-content: flex-end;
        background-color: #fff;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }
    }
  }
`;
